import { makeStyles } from '@map/theme';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(({ palette, zIndex }) => ({
  backdrop: {
    zIndex: zIndex.appBar + 1,
    color: palette.common.white,
    overscrollBehavior: 'contain',
  },
}));

const LoadingIndicator: FC<{ spinner?: boolean }> = ({ spinner = true }) => {
  const { classes } = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      {spinner && <CircularProgress color="inherit" />}
    </Backdrop>
  );
};
export default LoadingIndicator;
